module.exports = __webpack_public_path__ + "static/media/airpods.fcaad393.png";